module.exports = __webpack_public_path__ + "static/breathe-1.fb202941.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/breathe-1.jpeg
// module id = 447
// module chunks = 118792369664667